__turbopack_context__.v({
  "copyright": "wppNGq_copyright",
  "footer": "wppNGq_footer",
  "link-item": "wppNGq_link-item",
  "link-item-highlighted": "wppNGq_link-item-highlighted",
  "links-group": "wppNGq_links-group",
  "links-row": "wppNGq_links-row",
  "logo": "wppNGq_logo",
});
